const rgbString = (red, green, blue) => {
  const r2 = red.toFixed(0);
  const g2 = green.toFixed(0);
  const b2 = blue.toFixed(0);
  return `rgb(${r2}, ${g2}, ${b2})`;
};

const hslString = (hue, saturation, lightness) => {
  const h2 = hue.toFixed(0);
  const s2 = saturation.toFixed(0);
  const l2 = lightness.toFixed(0);
  return `hsl(${h2}, ${s2}%, ${l2}%)`;
};

const RGBtoHSL = (red, green, blue) => {
  // This algorithm comes from Wikipedia. There are two algorithms; the official
  // CSS HSL -> RGB algorithm doesn't use tangents, so I used the RGB -> HSL that didn't either.
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  let _h = 0;
  let l1 = (max + min) / 255 / 2;
  let s1 = (max - min) / 255 / (1 - Math.abs(2 * l1 - 1));
  if (max === min) {
    s1 = 0; // this compensates for the rare NaN scenarios and shortcircuits hue calculation
  } else if (max === red) {
    _h = (green - blue) / (max - min);
  } else if (max === green) {
    _h = (blue - red) / (max - min) + 2;
  } else if (max === blue) {
    _h = (red - green) / (max - min) + 4;
  }
  let h1 = (_h % 6) * 60;
  return { hue: h1, saturation: s1 * 100, lightness: l1 * 100 };
};

const calcPreviewColor = ({ warm, cool, red, green, blue }) => {
  if (red + green + blue > 0) {
    // default to RGB if not zero
    return rgbString(red, green, blue);
  } else if (warm > 0) {
    return hslString(34, (warm / 255) * 100, 90);
  } else if (cool > 0) {
    return hslString(203, (cool / 255) * 100, 95);
  }
  return rgbString(0, 0, 0);
};

const SATURATION_MAX = 90;
const RED_DIMMING_RATIO = 0.9;
const GREEN_DIMMING_RATIO = 0.95;

const calcPreviewColorBulb = ({ warm, cool, red, green, blue }) => {
  let hueValue;
  let saturationRatio;
  let lightnessRatio;

  if (warm + cool + red + blue + green === 0) {
    // All off
    hueValue = 0;
    saturationRatio = 0;
    lightnessRatio = 0.5;
  } else if (warm > 0) {
    // Only warm set
    saturationRatio = warm / 255;
    hueValue = 34;
    lightnessRatio = 0.8;
  } else if (cool > 0) {
    // Only cool set
    saturationRatio = cool / 255;
    hueValue = 203;
    lightnessRatio = 0.9;
  } else {
    // red and green on the bulb are not as bright, so suppress them in the preview
    let dimRed = RED_DIMMING_RATIO * red;
    let dimGreen = GREEN_DIMMING_RATIO * green;
    let hslObj = RGBtoHSL(dimRed, dimGreen, blue);
    hueValue = hslObj.hue;
    saturationRatio = hslObj.saturation / 100;
    lightnessRatio = hslObj.lightness / 100;
    // we want saturation and lightness over a smaller range
    saturationRatio =
      saturationRatio < 0.1
        ? 5 * saturationRatio
        : 0.5 + (1 - 0.5) * saturationRatio;
    lightnessRatio = 0.5 + (0.95 - 0.5) * lightnessRatio;
  }
  const saturation = saturationRatio * SATURATION_MAX;
  const hue = hueValue;
  const lightness = lightnessRatio * 100;
  return hslString(hue, saturation, lightness);
};

export { calcPreviewColor, calcPreviewColorBulb };



// WEBPACK FOOTER //
// ../nx-components/src/ColorPicker/utils.js